import api from './api';

const register = ({ email, firstName, lastName, password, companyName }) =>
  api.post('/auth/register', {
    email,
    firstName,
    lastName,
    password,
    companyName,
  });

const login = ({ email, password }) =>
  api.post('/auth/signOn', {
    email,
    password,
  });

const verify = ({ email, token }) =>
  api.post('/auth/verify', {
    email,
    token,
  });

const resendVerification = ({ email }) =>
  api.post('/auth/resendVerification', {
    email,
  });

const sendPasswordReset = ({ email }) =>
  api.post('/auth/sendPasswordReset', {
    email,
  });

const passwordResetWithToken = ({ email, token, password }) =>
  api.post('/auth/passwordResetWithToken', {
    email,
    token,
    password,
  });

const resetPassword = ({ oldPassword, newPassword, confirmPassword }) =>
  api.post('/auth/resetPassword', {
    oldPassword,
    newPassword,
    confirmNewPassword: confirmPassword,
  });

const verifyPassword = ({ email, password }) =>
  api.post('/auth/verifyPassword', { email, password });

const completeTwoFactor = ({ token, code }) => {
  return api.post('/auth/signOn/mfa', {
    token,
    code,
  });
};

const AuthService = {
  register,
  resendVerification,
  login,
  verify,
  sendPasswordReset,
  passwordResetWithToken,
  resetPassword,
  verifyPassword,
  completeTwoFactor,
};

export default AuthService;
